module.exports = __webpack_public_path__ + "static/media/specific-risk-moderate.3dd1b239.svg";